// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_about-module__link--3bVT0{color:#36b;cursor:pointer}.lawyer_about-module__link--3bVT0:hover{text-decoration:underline}.lawyer_about-module__break--2dgNq{color:#36b;cursor:pointer;word-break:break-all}.lawyer_about-module__break--2dgNq:hover{text-decoration:underline}.lawyer_about-module__hidden--1m_x7{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;cursor:pointer;color:#36b}.lawyer_about-module__hiddenLabel--2EJXF:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"link": "lawyer_about-module__link--3bVT0",
	"break": "lawyer_about-module__break--2dgNq",
	"hidden": "lawyer_about-module__hidden--1m_x7",
	"hiddenLabel": "lawyer_about-module__hiddenLabel--2EJXF"
};
module.exports = exports;
